import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrainingVideoBackendServer extends BaseBackend {

  postTrainingVideoClick(body: { videoId: string; videoTitle?: string }): Observable<object> {
    return this.post('/training-video-click', body);
  }

  getViewCounts(userId?: any ,startDate?: string | Date, endDate?: string | Date, isDealer?: boolean): Observable<{ videoId: string; videoTitle?: string; count: number }[]> {
    const params = {};
    if (userId != null) params['userId'] = userId;
    if (startDate != null) params['startDate'] = typeof startDate === 'string' ? startDate : (startDate as Date).toISOString?.() ?? String(startDate);
    if (endDate != null) params['endDate'] = typeof endDate === 'string' ? endDate : (endDate as Date).toISOString?.() ?? String(endDate);
    if (isDealer != null) params['isDealer'] = isDealer;
    const options = Object.keys(params).length ? { params } : undefined;
    return this.get('/training-video-click/stats', options) as Observable<{ videoId: string; videoTitle?: string; count: number }[]>;
  }
}
